import { useMutation, useQueryClient } from 'react-query';
import { useApiDelete, useApiPost, useApiQuery } from '../../../api';
import { useBuildVars } from '../../../config';
import { VendorLookUpResponse } from 'src/hooks/vendor-list';

export interface VendorSearchRequest {
  businessType?: string | null;
  countryCode?: string;
  vendorNameToSearch: string;
}

//get vendor name
export function useVendorSearchQuery(params: VendorSearchRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<VendorLookUpResponse[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendor',
    params,
    { enabled: params.vendorNameToSearch.length > 1 },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export interface OnHoldProgramRequest {
  programId: number;
}
export interface OnHoldProgramResult {
  createdby: string;
  onholdcreatedon: string;
  programid: number;
  programname: string;
  reason: string;
}
//get program on hold
export function useGetProgramOnHold(params: OnHoldProgramRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<OnHoldProgramResult[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/getOnholdProgram',
    params,
    undefined,
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
export interface PutProgramOnHoldOrActive {
  isActive: boolean;
  programId: number;
  reason: string;
  userId: string;
}
export interface ActiveHoldRequest {
  requestPreamble: PutProgramOnHoldOrActive;
}
export function useProgramHoldOrActive(request: ActiveHoldRequest) {
  const buildVars = useBuildVars();
  const queryClient = useQueryClient();
  const apiPost = useApiPost({ host: buildVars.VP_API_BASE });
  return useMutation(
    () =>
      apiPost(
        '/system.webapi.gds/api/v1/gdsCoreApiVendor/ActivateVendorProgram',
        request
      ),
    {
      onSuccess: (data) => {
        queryClient
          .invalidateQueries(
            '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorProgram'
          )
          .catch(() => undefined);
      },
    }
  );
}

export interface DeleteProgramRequest {
  deleteReason: string;
  deletedBy: string;
  vendorId: number;
  vendorProgramId: number;
}
export function useDeleteProgram() {
  const buildVars = useBuildVars();
  const queryClient = useQueryClient();
  const apiDelete = useApiDelete(buildVars.VP_API_BASE);
  return useMutation(
    (request: DeleteProgramRequest) =>
      apiDelete(
        '/system.webapi.gds/api/v1/gdsCoreApiVendor/DeleteDraftVendorProgram',
        request
      ),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries(
            '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorProgram'
          )
          .catch(() => undefined);
      },
    }
  );
}
